import { action, observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
/* eslint-disable max-len */

export interface IManagerBookingDiscountUsagesEntityAttributes extends IModelAttributes {
	usedAmount: number;

	alterationId: string;
	alteration: Models.AlterationEntity | Models.IAlterationEntityAttributes;
	managerBookingDiscountId: string;
	managerBookingDiscount: Models.ManagerBookingDiscountEntity | Models.IManagerBookingDiscountEntityAttributes;
}
@entity('ManagerBookingDiscountUsagesEntity', 'Manager booking discount usages')
export default class ManagerBookingDiscountUsagesEntity
	extends Model
	implements IManagerBookingDiscountUsagesEntityAttributes
{
	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = [];

	@observable
	@attribute<ManagerBookingDiscountUsagesEntity, number>()
	public usedAmount: number;

	@observable
	@attribute()
	public alterationId: string;

	@observable
	@attribute({ isReference: true, manyReference: false })
	public alteration: Models.AlterationEntity;

	@observable
	@attribute()
	public managerBookingDiscountId: string;

	@observable
	@attribute({ isReference: true, manyReference: false })
	public managerBookingDiscount: Models.ManagerBookingDiscountEntity;

	constructor(attributes?: Partial<IManagerBookingDiscountUsagesEntityAttributes>) {
		super(attributes);

		makeObservable(this);

		this.assignAttributes(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	public assignAttributes(attributes?: Partial<IManagerBookingDiscountUsagesEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.usedAmount !== undefined) {
				this.usedAmount = attributes.usedAmount;
			}
			if (attributes.alterationId !== undefined) {
				this.alterationId = attributes.alterationId;
			}
			if (attributes.alteration !== undefined) {
				if (attributes.alteration === null) {
					this.alteration = attributes.alteration;
				} else if (attributes.alteration instanceof Models.AlterationEntity) {
					this.alteration = attributes.alteration;
					this.alterationId = attributes.alteration.id;
				} else {
					this.alteration = new Models.AlterationEntity(attributes.alteration);
					this.alterationId = this.alteration.id;
				}
			}
			if (attributes.managerBookingDiscountId !== undefined) {
				this.managerBookingDiscountId = attributes.managerBookingDiscountId;
			}
			if (attributes.managerBookingDiscount !== undefined) {
				if (attributes.managerBookingDiscount === null) {
					this.managerBookingDiscount = attributes.managerBookingDiscount;
				} else if (attributes.managerBookingDiscount instanceof Models.ManagerBookingDiscountEntity) {
					this.managerBookingDiscount = attributes.managerBookingDiscount;
					this.managerBookingDiscountId = attributes.managerBookingDiscount.id;
				} else {
					this.managerBookingDiscount = new Models.ManagerBookingDiscountEntity(
						attributes.managerBookingDiscount,
					);
					this.managerBookingDiscountId = this.managerBookingDiscount.id;
				}
			}
		}
	}
}
